import {createReducer} from '@reduxjs/toolkit';
import uniqBy from 'lodash/uniqBy';

import {fetchOrdersRequest, reset} from '../actions/orders.js';

export const initialState = {
  loading: false,
  nextPage: null,
  list: [],
  permissions: {},
  error: null,
};

const orders = createReducer(initialState, builder => {
  builder.addCase(fetchOrdersRequest.pending, state => {
    state.loading = true;
    state.error = null;
  });

  builder.addCase(fetchOrdersRequest.rejected, (state, {payload}) => {
    state.loading = false;
    state.error = payload;
  });

  builder.addCase(
    fetchOrdersRequest.fulfilled,
    (state, {payload: {orders, nextPage}}) => {
      state.loading = false;
      state.error = null;
      state.nextPage = nextPage;
      // new orders take precedence over old ones
      state.list = uniqBy([...orders, ...state.list], 'id').sort((a, b) => {
        const dateA = new Date(a.created_on).getTime();
        const dateB = new Date(b.created_on).getTime();
        return dateB - dateA;
      });
    }
  );

  builder.addCase(reset, () => initialState);
});

export default orders;
